import React from 'react';
import { Image } from 'react-bootstrap';
import logoImg from 'images/or-logo-white.png';
import colors from 'utils/color';

const newStyle = {
	imgStyle: {
		backgroundColor: colors.primaryColor,
	},
};

const Logo = ({ style, height }) => {
	const styleProps = style;
	const mergedStyle = styleProps || {};

	return (
		<div
			style={{
				height: height || 'auto',
			}}
		>
			<Image
				src={logoImg}
				style={{ ...newStyle.imgStyle, ...mergedStyle }}
				rounded
				fluid
				alt='Logo'
			/>
		</div>
	);
};

export default Logo;
